(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.board = initialState || this.createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var i = 0; i < this.size; i++){
                    for(var j = 0; j < this.size; j++)if (this.board[i][j] === 0) emptyCells.push([
                        i,
                        j
                    ]);
                }
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), row = _emptyCells_Math_floor[0], col = _emptyCells_Math_floor[1];
                    var newTile = Math.random() < 0.9 ? 2 : 4;
                    this.board[row][col] = newTile;
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = this.createEmptyBoard();
                this.score = 0;
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status === "idle") this.restart();
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size; col++){
                    if (this.board[row][col] === 0) return true;
                    if (col < this.size - 1 && this.board[row][col] === this.board[row][col + 1]) return true;
                    if (row < this.size - 1 && this.board[row][col] === this.board[row + 1][col]) return true;
                }
                return false;
            }
        },
        {
            key: "rotateBoard",
            value: function rotateBoard() {
                var clockwise = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var newBoard = this.createEmptyBoard();
                for(var row = 0; row < this.size; row++){
                    for(var col = 0; col < this.size; col++)if (clockwise) newBoard[col][this.size - row - 1] = this.board[row][col];
                    else newBoard[this.size - col - 1][row] = this.board[row][col];
                }
                this.board = newBoard;
            }
        },
        {
            key: "slideAndMergeRow",
            value: function slideAndMergeRow(row) {
                var newRow = row.filter(function(val) {
                    return val !== 0;
                });
                for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
                    newRow[i] *= 2;
                    newRow[i + 1] = 0;
                    this.score += newRow[i];
                }
                return newRow.filter(function(val) {
                    return val !== 0;
                });
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var moved = false;
                for(var row = 0; row < this.size; row++){
                    var oldRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.board[row]);
                    var newRow = this.slideAndMergeRow(oldRow);
                    this.board[row] = (0, $227c6742e0ff6f82$export$71511d61b312f219)(newRow).concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(Array(this.size - newRow.length).fill(0)));
                    if (!moved && oldRow.toString() !== this.board[row].toString()) moved = true;
                }
                if (moved) {
                    this.addRandomTile();
                    this.checkGameOver();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.board.forEach(function(row) {
                    return row.reverse();
                });
                this.moveLeft();
                this.board.forEach(function(row) {
                    return row.reverse();
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.rotateBoard(false);
                this.moveLeft();
                this.rotateBoard(true);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.rotateBoard(true);
                this.moveLeft();
                this.rotateBoard(false);
            }
        },
        {
            key: "checkGameOver",
            value: function checkGameOver() {
                for(var row = 0; row < this.size; row++){
                    for(var col = 0; col < this.size; col++)if (this.board[row][col] === 2048) {
                        this.status = "win";
                        return;
                    }
                }
                if (!this.canMove()) this.status = "lose";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".button.start");
var $197cd56b15c33885$var$scoreDisplay = document.querySelector(".game-score");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        switch(e.key){
            case "ArrowLeft":
                $197cd56b15c33885$var$game.moveLeft();
                break;
            case "ArrowRight":
                $197cd56b15c33885$var$game.moveRight();
                break;
            case "ArrowUp":
                $197cd56b15c33885$var$game.moveUp();
                break;
            case "ArrowDown":
                $197cd56b15c33885$var$game.moveDown();
                break;
        }
        $197cd56b15c33885$var$updateUI();
    }
});
function $197cd56b15c33885$var$updateUI() {
    var gameBoard = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$scoreDisplay.textContent = $197cd56b15c33885$var$game.getScore();
    var cells = document.querySelectorAll(".field-cell");
    var cellIndex = 0;
    for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
        var value = gameBoard[row][col];
        var cell = cells[cellIndex];
        cell.className = "field-cell";
        cell.textContent = value > 0 ? value : "";
        if (value > 0) cell.classList.add("field-cell--".concat(value));
        cellIndex++;
    }
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        $197cd56b15c33885$var$winMessage.classList.remove("hidden");
        $197cd56b15c33885$var$loseMessage.classList.add("hidden");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
    } else if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
        $197cd56b15c33885$var$winMessage.classList.add("hidden");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
    }
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$updateUI();
    $197cd56b15c33885$var$startMessage.classList.add("hidden");
    $197cd56b15c33885$var$winMessage.classList.add("hidden");
    $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    $197cd56b15c33885$var$startButton.textContent = "Restart";
    $197cd56b15c33885$var$startButton.style.fontSize = "16px";
    $197cd56b15c33885$var$startButton.classList.remove("start");
    $197cd56b15c33885$var$startButton.classList.add("restart");
    $197cd56b15c33885$var$startButton.blur();
});

})();
//# sourceMappingURL=index.96db0170.js.map
